import React from 'react';
import Svg from '../Svg';
import { SvgProps } from '../types';

const Icon: React.FC<SvgProps> = props => (
  <Svg viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.87257 17.4915H19.3602V17.4915C19.6918 17.4915 19.9632 17.7559 19.9632 18.0792C19.9632 18.4024 19.6918 18.6669 19.3602 18.6669H0.666504V1.9211C0.666504 1.59782 0.937849 1.33348 1.26948 1.3335C1.60111 1.3335 1.87257 1.59784 1.87257 1.9211V17.4915ZM10.3149 16.6104V2.92011C10.3149 2.53812 10.0134 2.21494 9.65162 2.21494H7.66148C7.29985 2.21494 6.9982 2.5381 6.9982 2.92011V16.6104H10.3149ZM6.09377 16.6103V7.03296C6.09377 6.65107 5.79212 6.35731 5.43047 6.35731H3.44033C3.07861 6.35731 2.77706 6.68038 2.77706 7.03296V16.6103H6.09377ZM14.5358 10.5582V16.6102H11.219V10.5582C11.219 10.1764 11.5206 9.8532 11.8825 9.8532H13.8723C14.2345 9.8532 14.5358 10.1764 14.5358 10.5582ZM18.757 16.6103V7.03296C18.757 6.65107 18.4555 6.35731 18.0936 6.35731H16.1037C15.7416 6.35731 15.4402 6.68038 15.4402 7.03296V16.6103H18.757Z"
    />
  </Svg>
);

export default Icon;
